/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ResourceAssignmentStore } from 'src/core/stores/ResourceAssignmentStore';
import { Region } from 'src/core/types/regionTypes';
import { LuisConstants } from 'src/core/utils/LuisConstants';

export const updateRegionResourceAssignment = (
    id: Region,
    newAssignment: ResourceAssignmentStore,
    regionDeploymentItems: ResourceAssignmentStore[]
) => {
    const indexToUpdate = regionDeploymentItems.findIndex(item => item.id === id);
    regionDeploymentItems[indexToUpdate] = newAssignment;
};

export const getResourceInfo = (resourceId: string) => {
    const resourceInfo = resourceId?.split('/');

    return {
        subscriptionId: resourceInfo?.[2],
        resourceName: resourceInfo?.[resourceInfo.length - 1]
    };
};

export const getRegionName = (regionId: Region) =>
    Object.entries({ ...LuisConstants.CustomText.PredictionAllowedRegions, ...LuisConstants.Clu.PredictionAllowedRegions }).find(
        ([key, _]) => key === regionId
    )?.[1] ?? '--';
